<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m12.953 5.798-3.18 7.597-1.23-3.188-.615-.24-2.573-.997 7.598-3.173ZM15.75 3 2.25 8.648v.735l5.13 1.987 1.98 5.13h.735L15.75 3ZM3.375 0l1.074 2.301L6.75 3.375 4.449 4.449 3.375 6.75 2.301 4.449 0 3.375l2.301-1.074L3.375 0ZM9 0l.716 1.534 1.534.716-1.534.716L9 4.5l-.716-1.534L6.75 2.25l1.534-.716L9 0Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
